export default __webpack_public_path__ + "static/ConcreteSectionGeometry-6407620dd898234e443edaa5118f404e.jpg";